<ul class="sidebar-nav">
  <li class="sidebar-item">
      <a href="#/panel-admin" class="sidebar-link">
          <!--i class="fa-solid fa-list pe-2"></i-->
          Inicio
      </a>
  </li>

  <ng-container *ngFor="let menu of menuList; let x = index">
    <li class="sidebar-item" *ngIf="menu.menu_padre === '' ">
      <a *ngIf="menu.menu_url !== '' && menu.aplica_menu" [href]="'#/panel-admin/' + menu.menu_url" class="sidebar-link" attr.data-bs-target="#pages{{menu.id_menu}}"  >
        <!--i class="fa-solid fa-file-lines pe-2"></i-->
        {{menu.menu}}
      </a>
      <a *ngIf="menu.menu_url === '' && menu.aplica_menu" style="cursor: pointer;" class="sidebar-link collapsed" attr.data-bs-target="#pages{{menu.id_menu}}" data-bs-toggle="collapse" aria-expanded="false" >
        <!--i class="fa-solid fa-file-lines pe-2"></i-->
        {{menu.menu}}
      </a>
      <ul id="pages{{menu.id_menu}}" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar" *ngFor="let menuHijo of menuList; let y = index">
        <li class="sidebar-item" *ngIf='menuHijo.menu_padre === menu.id_menu.toString() && menuHijo.aplica_menu'>
            <a *ngIf="menuHijo.menu_url !== ''" [href]="'#/panel-admin/' + menuHijo.menu_url" class="sidebar-link">{{menuHijo.menu}}</a>
        </li>
      </ul>
    </li>
  </ng-container>


<!--

  <li class="sidebar-item">
      <a href="#" class="sidebar-link collapsed" data-bs-target="#pages" data-bs-toggle="collapse"
          aria-expanded="false">
          Pages
      </a>
      <ul id="pages" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Page 1</a>
          </li>
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Page 2</a>
          </li>
      </ul>
  </li>
  <li class="sidebar-item">
      <a href="#" class="sidebar-link collapsed" data-bs-target="#posts" data-bs-toggle="collapse"
          aria-expanded="false">
          Posts
      </a>
      <ul id="posts" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
          <li class="sidebar-item" style="color: #016e97;">
              <a href="#" class="sidebar-link">Post 1</a>
          </li>
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Post 2</a>
          </li>
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Post 3</a>
          </li>
      </ul>
  </li>
  <li class="sidebar-item">
      <a href="#" class="sidebar-link collapsed" data-bs-target="#auth" data-bs-toggle="collapse"
          aria-expanded="false">
          Auth
      </a>
      <ul id="auth" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Login</a>
          </li>
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Register</a>
          </li>
          <li class="sidebar-item">
              <a href="#" class="sidebar-link">Forgot Password</a>
          </li>
      </ul>
  </li>
  <li class="sidebar-item">
      <a href="#" class="sidebar-link collapsed" data-bs-target="#multi" data-bs-toggle="collapse"
          aria-expanded="false">
          Multi Dropdown
      </a>
      <ul id="multi" class="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar">
          <li class="sidebar-item">
              <a href="#" class="sidebar-link collapsed" data-bs-target="#level-1"
                  data-bs-toggle="collapse" aria-expanded="false">Level 1</a>
              <ul id="level-1" class="sidebar-dropdown list-unstyled collapse">
                  <li class="sidebar-item">
                      <a href="#" class="sidebar-link">Level 1.1</a>
                  </li>
                  <li class="sidebar-item">
                      <a href="#" class="sidebar-link">Level 1.2</a>
                  </li>
              </ul>
          </li>
      </ul>
  </li>
-->


</ul>
